import { useParams } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';

import { useRotateDeviceMutation } from '../../../../queries';

function Rotate({ degree, setDegree }) {
    const { t } = useTranslation();
    const options = [
        { name: t('devices.setup_rotate_0'), code: '0' },
        { name: t('devices.setup_rotate_90'), code: '90' },
        { name: t('devices.setup_rotate_180'), code: '180' },
        { name: t('devices.setup_rotate_270'), code: '270' },
    ];
    const { id } = useParams();
    const rotateDevice = useRotateDeviceMutation();

    const degreeHandler = async (e) => {
        const newDegree = e.value;
        setDegree(newDegree);
        await rotateDevice.mutateAsync({
            id: id,
            data: { rotation: newDegree }
        })
    }

    return (
        <>
            <div className="card-body pt-1 pb-1">
                <div className="card-header p-0 mb-2 ">
                    <div className=' d-flex align-items-center justify-content-between mb-2'>
                        <h5 className="m-0 me-2 ">{t('devices.setup_rotate')}</h5>
                        <small>{rotateDevice?.isLoading ? t('devices.setup_updating') : ""}</small>
                    </div>
                    <Dropdown className='w-100' value={degree} disabled={rotateDevice?.isLoading}
                        options={options} onChange={degreeHandler}
                        optionLabel="name" optionValue="code"
                        placeholder={t('devices.setup_rotate_placeholder')}
                    />
                </div>
            </div>
        </>
    )
}

export default Rotate